import React from 'react';

var LogoLoader = function (_a) {
    var src = _a.src;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "loading-content-middle-img" }),
        React.createElement("div", { className: "loading-c-middle-ins logo" },
            React.createElement("img", { src: src, alt: "logo" }))));
};

export { LogoLoader };
